import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _PUSH_NOTIFICATION_URL = "push-notification";

export async function getPushNotificationList(params) {
    const response = await ApiBase.get(`${_PUSH_NOTIFICATION_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function createPushNotification(params) {
    const response = await ApiBase.post(`${_PUSH_NOTIFICATION_URL}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_SEND_NOTIFICATION"))

    return response;
}